/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_InactiveInputs */

const cs_sreality_inactive = /** @type {(inputs: Sreality_InactiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pozastaveno`)
};

const en_sreality_inactive = /** @type {(inputs: Sreality_InactiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paused`)
};

/**
* | output |
* | --- |
* | "Paused" |
*
* @param {Sreality_InactiveInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_inactive = /** @type {((inputs?: Sreality_InactiveInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_InactiveInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_inactive(inputs)
	return cs_sreality_inactive(inputs)
});